import styled from 'styled-components'
import { Box } from '@rebass/grid'
import media from 'utils/media'

const StyledBox = styled(Box)`
   max-width: 100%;
   display: block;

   ${media.greaterThan('sm')`
      max-width: 540px;
   `};

   ${media.greaterThan('smd')`
      max-width: 610px;
   `};

   ${media.greaterThan('md')`
      max-width: calc(100% - 76px);
   `};

   ${media.greaterThan('lg')`
      max-width: 960px;
   `};

   ${media.greaterThan('xl')`
      max-width: 1140px;
   `};

   ${media.greaterThan('xxl')`
      max-width: 1232px;
   `};
`

StyledBox.defaultProps = {
   mx: 'auto',
   px: ['16px', '12px'],
}

export default StyledBox
